import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Organization, Label, User } from "@/types";

type OrganizationState = {
  currentOrganization: Organization | null;
  currentLabel: Label | null;
  setSelection: (org: Organization, label: Label) => void;
  clearSelection: () => void;
  initFromUser: (user: User | null | undefined) => void;
};

export const useOrganizationStore = create<OrganizationState>()(
  persist(
    (set, get) => ({
      currentOrganization: null,
      currentLabel: null,
      setSelection: (org, label) =>
        set({ currentOrganization: org, currentLabel: label }),
      clearSelection: () =>
        set({ currentOrganization: null, currentLabel: null }),
      initFromUser: (user) => {
        const { currentLabel } = get();
        if (!user || currentLabel) return;

        const orgsWithLabels = user.organizations.filter(
          (o) => o.labels?.length
        );
        if (!orgsWithLabels.length) return;

        const defaultOrg = orgsWithLabels[0];
        const defaultLabel = defaultOrg.labels[0];
        set({ currentOrganization: defaultOrg, currentLabel: defaultLabel });
      },
    }),
    { name: "organization-selection" }
  )
);
